import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type ThoughtBubbleFlowModel from './thought-bubble-flow';

export default class ThoughtBubbleStepModel extends Model {
  @attr declare elementSelector: string;
  @attr declare title: string;
  @attr declare description: string;
  @attr declare side: string;
  @attr declare align: string;
  @attr declare disableActiveInteraction: boolean;
  @attr declare order: number;

  @belongsTo('thought-bubble-flow', { async: false, inverse: 'steps' })
  declare flow: ThoughtBubbleFlowModel;

  [Type] = 'thought-bubble-step' as const;
}
